<div class="otp-container">
  <div class="otp-inputs-wrapper">
    <input
      *ngFor="let value of otpValues; let i = index; trackBy: trackByIndex"
      #otpInput
      type="text"
      inputmode="numeric"
      maxlength="1"
      class="otp-input"
      [value]="value"
      [disabled]="isDisabled"
      (input)="onInputChange(i, $event)"
      (keydown)="onKeyDown(i, $event)"
      (paste)="onPaste($event)"
      [attr.aria-label]="'Dígito ' + (i + 1) + ' del código'"
    />
  </div>
</div>
